module.exports = __webpack_public_path__ + "static/media/app-screenshots-v2.07c74784.png";